import React from "react";
import { useSelector } from "react-redux";
import EssenceProduct from "./EssenceProduct";


const Section = () => {
    const sections = useSelector((state) => state.step.sections);

    const toUpper = (sectionName) => {
        let newSectionName = sectionName.toUpperCase()
    
        return newSectionName
      }
  
    return (
      <>
        {sections.map((section) => (
            <div key={section.id}>
                <div className="mb-3">
                    <div className="bois-de-pays">
                        <span className="text-2 ">{toUpper(section.name)}</span>
                    </div>
                </div>
                <p className="mb-4">{section.description}</p>
                <div className="row">
                {section.products?.map((product) => (
                    <EssenceProduct
                        image="/assets/images/pin_cl4_choix_us_bridge_1_retravaill.png"
                        alt={product.name}
                        price={product.price}
                        checkName={product.name}
                        name={product.name}
                    />
                ))}
                </div>
            </div>
        ))}
      </>
    );
  };
  

export default Section